import PrivateRoute from './PrivateRoute'
export { PrivateRoute }
export default PrivateRoute



// WEBPACK FOOTER //
// ./src/components/PrivateRoute/index.js